import { useEffect } from "react";
import AppConstants from "../constants/AppConstants";
import cookieService from "../services/cookieService";

const useAuthWatcher = (setUserData) => {
  useEffect(() => {
    const handleLogout = () => {
      cookieService.remove(AppConstants.CS_KEY.ACCESS_TOKEN, AppConstants.COOKIE_CONFIG);
      cookieService.remove(AppConstants.CS_KEY.REFRESH_TOKEN, AppConstants.COOKIE_CONFIG);
      cookieService.remove(AppConstants.CS_KEY.USER_PROFILE, AppConstants.COOKIE_CONFIG);
      cookieService.remove(AppConstants.CS_KEY.RETURN_URL_AFTER_LOGIN, AppConstants.COOKIE_CONFIG);
      setUserData("");
    };

    const cookieToken = cookieService.get(AppConstants.CS_KEY.ACCESS_TOKEN);
    const raw = cookieService.get(AppConstants.CS_KEY.USER_PROFILE);

    if (!cookieToken) {
      handleLogout();
    } else if (raw) {
      try {
        setUserData(JSON.parse(raw));
      } catch (err) {
        console.error("Error parsing user data:", err);
        handleLogout();
      }
    }

    const interval = setInterval(() => {
      const currentCookieToken = cookieService.get(AppConstants.CS_KEY.ACCESS_TOKEN);
      if (!currentCookieToken) {
        handleLogout();
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, [setUserData]);
};

export default useAuthWatcher;
